<template>
  <div id="userview" class="viewport">
    <div class="columns">
      <div class="column">
        <h1>Users</h1>
      </div>
      <div class="column alignRight">
        <button class="button is-pulled-right" v-on:click="newUser">Neuer User</button>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="borderround">        
          <div class="user head">
            <span class="name">Username</span>
            <span class="e_mail">E-Mail</span>
            <span class="role">Rolle</span>    
            <span class="active_user">Aktiv</span>    
          </div>        
          <user :user.sync="user" :key="user.id" v-for="(user, key, index) in users"></user>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import User from '@/components/Users/User';

export default {

  name: "UsersView",
  components: {
    User
  },
  data() {
      return {
            users: [],          
        }
  },
  sockets: {
    getUsersList(r){
      console.log(r)
      this.users = []      
      this.users = r 
    }
  },
  methods: {
    newUser(e){
      e.preventDefault();
      this.$router.replace({ name: "UserSingle", params: {userid: 'new' } })
    }
  },
  
  mounted: function(){
    this.$socket.emit('getUsersList');
  }
}
</script>